module.exports = "<p ng-repeat=\"news in $ctrl.data\">\n    <a style=\"float:right; margin-left: 8px\" ng-href=\"/news/{{news._id}}\" class=\"btn btn-sm btn-more\"><i class=\"fa fa-arrow-circle-right\"></i> more</a>\n    <b>{{news.title}}</b><br/><em ng-bind-html=\"$ctrl.getPreviewText(news.body)\"></em>\n</p>"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/news-widget/news-widget.component.html
// module id = 561
// module chunks = 0